const marmoreioMenu = {
  tenantId: 'marmoreio',
  sections: [
    {
      id: 'bovino',
      name: 'Bovino',
      items: [
        {
          id: 'picanha',
          name: 'Picanha',
          summary: 'Clássico do churrasco — Malbec ou Cabernet Sauvignon.',
          description:
            'A picanha pede vinhos com fruta madura e taninos capazes de acompanhar a gordura e a intensidade da grelha. O Malbec é a escolha natural pela textura aveludada e pelos aromas de frutas negras que valorizam o sabor do corte. Para quem prefere mais estrutura e rusticidade, o Cabernet Sauvignon é uma excelente alternativa.',
          image: '/images/menus/marmoreio/picanha.jpg',
          featuredWineSlug: 'master-fan-club-malbec',
          wineSlugs: [
            'master-fan-club-malbec',
            'san-telmo-malbec',
            'valle-de-chillan-cabernet-sauvignon',
          ],
        },
        {
          id: 'ancho',
          name: 'Ancho',
          summary: 'Corte argentino marmorizado — Cabernet Sauvignon ou Malbec.',
          description:
            'O tradicional corte argentino encontra excelente equilíbrio com o Cabernet Sauvignon, cuja estrutura tânica harmoniza perfeitamente com o marmoreio característico da carne, proporcionando uma experiência intensa e elegante. Para quem prefere taninos mais macios e aveludados, o Malbec é uma excelente alternativa, oferecendo uma harmonização equilibrada, com fruta madura e textura sedosa que valorizam o sabor do corte.',
          image: '/images/menus/marmoreio/ancho.jpg',
          featuredWineSlug: 'valle-de-chillan-cabernet-sauvignon',
          wineSlugs: [
            'valle-de-chillan-cabernet-sauvignon',
            'san-telmo-malbec',
            'master-fan-club-malbec',
          ],
        },
        {
          id: 'alcatra',
          name: 'Alcatra',
          summary: 'Macio e marcante — Carmenere chileno (ou Reserva).',
          description:
            'A maciez e o sabor marcante deste corte harmonizam perfeitamente com a fruta madura e as notas de especiarias características do Carmenere chileno. É uma excelente escolha, oferecendo equilíbrio e frescor que valorizam a suculência da carne. Para quem aprecia vinhos com maior complexidade e estágio em barricas de carvalho, um Carménère Reserva é a opção ideal, apresentando maior estrutura, notas tostadas e um final elegante que complementa a intensidade do corte.',
          image: '/images/menus/marmoreio/alcatra.jpg',
          featuredWineSlug: 'antares-carmenere',
          wineSlugs: ['antares-carmenere', 'santa-maria-apalta-carmenere'],
        },
        {
          id: 'file-mignon',
          name: 'Filé Mignon',
          summary: 'Corte delicado — Merlot; com molhos, Syrah ou Tannat.',
          description:
            'Aqui o que vai coordenar as harmonizações são as diversas combinações possíveis do corte. Por ser um corte delicado se inicia com um Merlot e caso forem acrescidos molhos ou combinações mais intensas se introduz o Syrah ou, em última instância, o Tannat.',
          image: '/images/menus/marmoreio/file-mignon.jpg',
          featuredWineSlug: 'punti-ferrer-merlot',
          wineSlugs: [
            'punti-ferrer-merlot',
            'yellow-tail-shiraz-australia',
            'filgueira-tannat',
          ],
        },
        {
          id: 'assado-em-tiras-premium',
          name: 'Assado em Tiras Premium',
          summary: 'Intensidade e suculência — Shiraz.',
          description:
            'Harmoniza bem com vinhos elaborados a partir da Shiraz, cuja estrutura marcada por taninos firmes, acidez equilibrada e notas de especiarias realça a intensidade e a suculência do corte.',
          image: '/images/menus/marmoreio/assado-em-tiras-premium.jpg',
          featuredWineSlug: 'yellow-tail-shiraz-australia',
          wineSlugs: ['yellow-tail-shiraz-australia'],
        },
        {
          id: 't-bone',
          name: 'T-Bone',
          summary: 'Estrutura e personalidade — Cabernet Sauvignon ou Shiraz.',
          description:
            'O T-Bone exige vinhos de personalidade e estrutura. O Cabernet Sauvignon é uma harmonização clássica, com taninos firmes e notas de frutas negras capazes de envolver o marmoreio e realçar a intensidade da carne. A Shiraz também é uma excelente escolha, pois sua estrutura aliada aos taninos sedosos complementa a suculência do corte.',
          image: '/images/menus/marmoreio/t-bone.jpg',
          featuredWineSlug: 'valle-de-chillan-cabernet-sauvignon',
          wineSlugs: [
            'valle-de-chillan-cabernet-sauvignon',
            'yellow-tail-shiraz-australia',
          ],
        },
        {
          id: 'prime-steak',
          name: 'Prime Steak',
          summary: 'Corte nobre — Malbec macio ou Cabernet estruturado.',
          description:
            'Este corte nobre harmoniza muito bem com vinhos tintos de médio a grande corpo. A sugestão é o Malbec para quem prefere vinhos mais macios ou o Cabernet Sauvignon para quem opta por acumular rusticidade com o marmoreio do corte.',
          image: '/images/menus/marmoreio/prime-steak.jpg',
          featuredWineSlug: 'san-telmo-malbec',
          wineSlugs: [
            'san-telmo-malbec',
            'valle-de-chillan-cabernet-sauvignon',
          ],
        },
        {
          id: 'bombom-da-alcatra',
          name: 'Bombom da Alcatra',
          summary: 'Suculento e delicado — Carmenere, Merlot ou Malbec.',
          description:
            'Por ser um corte suculento, porém mais delicado do que o Ancho ou o T-Bone, harmoniza melhor com vinhos de médio a grande corpo, sendo as melhores opções, em escala crescente: Carmenere, Merlot e Malbec.',
          image: '/images/menus/marmoreio/bombom-da-alcatra.jpg',
          featuredWineSlug: 'antares-carmenere',
          wineSlugs: [
            'antares-carmenere',
            'punti-ferrer-merlot',
            'san-telmo-malbec',
          ],
        },
        {
          id: 'flat-iron',
          name: 'Flat Iron',
          summary: 'Sabor bovino pronunciado — Malbec, Cabernet ou Syrah.',
          description:
            'Como apresenta uma textura rica e pronunciado sabor bovino, as melhores opções são o Malbec pelo equilíbrio com a suculência do corte, o Cabernet Sauvignon para quem prefere maior estrutura e persistência, ou o Syrah para quem se interessa pelo pronunciado sabor de especiarias.',
          image: '/images/menus/marmoreio/flat-iron.jpg',
          featuredWineSlug: 'san-telmo-malbec',
          wineSlugs: [
            'san-telmo-malbec',
            'valle-de-chillan-cabernet-sauvignon',
            'yellow-tail-shiraz-australia',
          ],
        },
        {
          id: 'prime-rib',
          name: 'Prime Rib',
          summary: 'Dianteiro nobre — Cabernet Sauvignon ou Tannat.',
          description:
            'Este corte nobre do dianteiro bovino demanda um vinho estruturado. O Cabernet Sauvignon é uma escolha clássica pelas frutas negras e carvalho; o Tannat é uma harmonização de grande personalidade, com taninos firmes e bem estruturados que complementam os sabores desenvolvidos pela grelha.',
          image: '/images/menus/marmoreio/prime-rib.jpg',
          featuredWineSlug: 'valle-de-chillan-cabernet-sauvignon',
          wineSlugs: ['valle-de-chillan-cabernet-sauvignon', 'filgueira-tannat'],
        },
        {
          id: 'chorizo',
          name: 'Chorizo',
          summary: 'Maciez e gordura — Cabernet Sauvignon ou Malbec.',
          description:
            'O Chorizo destaca-se pelo equilíbrio entre maciez, suculência e sabor marcante. Sua textura e a camada de gordura externa encontram perfeita harmonia com o Cabernet Sauvignon. Para uma experiência de inspiração argentina, o Malbec é uma escolha indispensável em razão de seus taninos aveludados.',
          image: '/images/menus/marmoreio/chorizo.jpg',
          featuredWineSlug: 'valle-de-chillan-cabernet-sauvignon',
          wineSlugs: [
            'valle-de-chillan-cabernet-sauvignon',
            'san-telmo-malbec',
          ],
        },
        {
          id: 'cupim-na-laranja',
          name: 'Cupim na Laranja',
          summary: 'Gordura + laranja — Carmenere ou Merlot de barrica.',
          description:
            'A riqueza e a gordura da carne pedem vinhos estruturados, enquanto a acidez e o leve dulçor da laranja exigem vinhos com boa acidez e fruta expressiva. Experimente com a Carmenere ou com um Merlot envelhecido em barrica.',
          image: '/images/menus/marmoreio/cupim-na-laranja.jpg',
          featuredWineSlug: 'antares-carmenere',
          wineSlugs: ['antares-carmenere', 'la-tierra-rocosa-merlot'],
        },
        {
          id: 'maca-de-peito-na-laranja',
          name: 'Maçã de Peito na Laranja',
          summary: 'Fruta para a laranja — Carmenere ou Merlot.',
          description:
            'A pedida é um vinho com muita fruta para se somar à laranja. Pode-se optar pelo Carmenere ou por um Merlot reserva.',
          image: '/images/menus/marmoreio/maca-de-peito-na-laranja.jpg',
          featuredWineSlug: 'antares-carmenere',
          wineSlugs: ['antares-carmenere', 'punti-ferrer-merlot'],
        },
        {
          id: 'coxao-mole-no-chimichurri',
          name: 'Coxão Mole no Chimichurri',
          summary: 'Ervas e acidez — Cabernet Franc ou Malbec.',
          description:
            'O perfil aromático do chimichurri, marcado por ervas, alho, especiarias e um toque de acidez, pede vinhos com boa acidez, taninos maduros e caráter herbáceo. Pode-se optar por um Cabernet Franc pelo perfil herbáceo ou pelo Malbec por fruta mais madura.',
          image: '/images/menus/marmoreio/coxao-mole-no-chimichurri.jpg',
          featuredWineSlug: 'filgueira-tannat-cabernet-franc',
          wineSlugs: [
            'filgueira-tannat-cabernet-franc',
            'san-telmo-malbec',
          ],
        },
      ],
    },
    {
      id: 'suino',
      name: 'Suíno',
      items: [
        {
          id: 'linguica-cuiabana',
          name: 'Linguiça Cuiabana',
          summary: 'Queijo e ervas — Carmenere ou Quinta dos Bons Ventos.',
          description:
            'O sabor marcante do queijo e o leve toque de ervas pedem vinhos com boa acidez, fruta expressiva e taninos moderados, como o Carmenere ou um vinho português de Lisboa como o Quinta dos Bons Ventos.',
          image: '/images/menus/marmoreio/linguica-cuiabana.jpg',
          featuredWineSlug: 'antares-carmenere',
          wineSlugs: ['antares-carmenere', 'quinta-do-bons-ventos'],
        },
      ],
    },
  ],
};

export default marmoreioMenu;
